var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: {
        "mask-closable": false,
        fullscreen: "",
        transfer: false,
        width: "450",
        closable: false,
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c("div", { staticClass: "modalhead" }, [
        _c("div", {}, [_vm._v("流水详情")]),
        _c("div", { staticClass: "secondTitle" }, [
          _vm._v(_vm._s(_vm.fundFlowId)),
        ]),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("业务类型")]),
          _c("div", { staticClass: "fr" }, [
            _vm._v(_vm._s(this.$filters.getFondTypeName(_vm.fundType))),
          ]),
        ]),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("交易流水号")]),
          _c("div", { staticClass: "fr" }, [_vm._v(_vm._s(_vm.transactionId))]),
        ]),
        _vm.fundType == "DEPOSIT_REFUND"
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [_vm._v("相关退款流水")]),
              _c("div", { staticClass: "fr" }, [_vm._v(_vm._s(_vm.flowId))]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "line" }, [
          _vm.fundType == "DEPOSIT"
            ? _c("div", { staticClass: "fl" }, [_vm._v("持有金额")])
            : _vm._e(),
          _vm.fundType != "DEPOSIT"
            ? _c("div", { staticClass: "fl" }, [_vm._v("返还金额")])
            : _vm._e(),
          _vm.fundType == "DEPOSIT"
            ? _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(this.$filters.money(_vm.creditAmount)) +
                    " " +
                    _vm._s(_vm.currency)
                ),
              ])
            : _vm._e(),
          _vm.fundType != "DEPOSIT"
            ? _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(this.$filters.money(_vm.debitAmount)) +
                    " " +
                    _vm._s(_vm.currency)
                ),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "line" }, [
          _vm.fundType == "DEPOSIT"
            ? _c("div", { staticClass: "fl" }, [_vm._v("持有时间")])
            : _vm._e(),
          _vm.fundType != "DEPOSIT"
            ? _c("div", { staticClass: "fl" }, [_vm._v("返还时间")])
            : _vm._e(),
          _c("div", { staticClass: "fr" }, [
            _vm._v(_vm._s(this.$filters.timestampToDatetime(_vm.created))),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "textright", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              staticClass: "modal-btn",
              attrs: { type: "primary", size: "spec" },
              on: { click: _vm.sure },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }